import React from "react";
import styled, { device, themeGet, css } from "../../../styles";
import { Anchor } from "../../UI/Anchor";

export const StyledLogo = styled(({ ...rest }) => <Anchor {...rest} />)`
  display: flex;
  height: -webkit-fill-available;
`;
